import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import draggable from "vuedraggable";
import ButtonCommon from '../buttons/ButtonCommon.vue';
import Tooltip from '../tooltip/Tooltip.vue'
//Type for each Item in array
type ArrayValue = {
  text: '';
  value: '';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SortableList',
  props: {
    value: null,
    upBtnText: null,
    downBtnText: null,
    height: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: ArrayValue[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: ArrayValue[],
  upBtnText: string,
  downBtnText: string,
  height?: string | number,
};





const drag = ref(false);
const heightValue = computed(() => props.height ? ((typeof props.height === 'number') ? props.height + 'px' : props.height) : undefined);

const valueList = computed({
  get: () => props.value,
  set: (newValue) => {
    if (newValue !== props.value) {
      emit("input", newValue);
    }
  }
});

function moveTop(index: number) {
  const element = valueList.value[index];
  const list = valueList.value.slice();
  list.splice(index,1);
  valueList.value = [ element, ...list ];
}

function moveBottom(index: number) {
  const element = valueList.value[index];
  const list = valueList.value.slice();
   list.splice(index,1);
  valueList.value = [ ...list, element ];
}


return { __sfc: true,props, emit, drag, heightValue, valueList, moveTop, moveBottom, draggable, ButtonCommon, Tooltip }
}

})